import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectShowMenu } from "./../providers/redux/menu/menu.selectors";
import { hide, show } from "./../providers/redux/menu/menu.slice";
import { getArticleBySlug, getArticlesByEndpoint } from "./mockData";

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

const useFloatingNavigation = () => {
    const [Y, setY] = useState(window.scrollY);
    const currY = useDebounce(Y, 300);

    //Redux
    const dispatch = useDispatch();
    const isShown = useSelector(selectShowMenu);
    //Setting up Y from window.scrollY listener
    const listenerRef = useRef();

    listenerRef.current = () => {
        const setupY = () => setY(window.scrollY);
        window.addEventListener("scroll", setupY);

        return () => window.removeEventListener("scroll", setupY);
    };

    useEffect(() => listenerRef.current(), []);

    useEffect(() => {
        if (window.innerWidth <= 1050) {
            dispatch(show());
            return;
        }
        if (currY >= 450 && !isShown) {
            dispatch(show());
        } else if (currY <= 450 && isShown) {
            dispatch(hide());
        }
    }, [currY, dispatch, isShown]);
};

const useFetch = (url) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useLayoutEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                setError(null);

                // Simulate API delay
                await new Promise((resolve) => setTimeout(resolve, 500));

                let mockData;

                if (url && url.includes("articles?slug=")) {
                    // Single article by slug
                    const slug = url.split("articles?slug=")[1];
                    const article = getArticleBySlug(slug);
                    mockData = article ? [article] : null;
                } else if (url && url.includes("articles")) {
                    // Articles list
                    mockData = getArticlesByEndpoint(url);
                } else {
                    // Default articles
                    mockData = getArticlesByEndpoint(
                        "articles?_sort=position:DESC"
                    );
                }

                setData(mockData);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setError(new Error(`Something went wrong. Error: ${error}`));
            }
        }

        fetchData();
    }, [url]);

    return { data, loading, error };
};

export { useDebounce, useFetch, useFloatingNavigation };
